export default "__VITE_ASSET__D69u0mr9__"